import i18next from '../i18next';
import { isVa } from '../platform/environment';
import { isZh } from '@meego/utils/src/language/env/base';
// import logoCn from '../asset/svg/logo_Cn.ts';
// import logoEn from '../asset/svg/logo_En.ts';
// import logoVaEn from '../asset/svg/logo_va.ts';
import { defaultConfig } from './config.default';

declare global {
  interface Window {
    larkLoginHost: string;
  }
}

const kaTenantConfig = /*#__PURE__*/ (() => ({
  get brand_name() {
    return i18next.t('Meego_Shared_Web_Common_FeishuProject');
  },
  get feishu_brand_name() {
    return i18next.t('Meego_Shared_Web_Common_Feishu');
  },
  get web_title() {
    return i18next.t('Meego_Shared_Web_Common_FeishuProject');
  },
  get workbench_title() {
    return i18next.t('Meego_Shared_Web_Common_FeishuProject');
  },
  get brand_desc() {
    return `${i18next.t('Meego_Shared_Web_Common_FeishuProject')} - ${i18next.t(
      'Meego_Shared_Web_Common_CollaborationPlatformTailoredForYou',
    )}`;
  },
  get logo_url_promise() {
    if (isVa) {
      return import('../asset/svg/logo_va.ts');
    }
    return isZh ? import('../asset/svg/logo_Cn.ts') : import('../asset/svg/logo_En.ts');
  },
}))();

const config = /*#__PURE__*/ (() => ({
  ...defaultConfig,
  larkPassportTemplateId: undefined,
  region: 'cn',
  avatarDomain: `${window.location.origin}/goapi`,
  host: window.location.origin,
  hostForGo: `${window.location.origin}/goapi`,
  larkLoginHost: window.larkLoginHost,
  currentHost: window.location.origin,
  guideLink: 'https://bytedance.feishu.cn/docs/doccnXOiqRbhTCZ7OxC1uKdAYfe',
  tosBucket: 'meego-business',
  tenantConfig: kaTenantConfig,
  externalHiddenFields: [
    'need_ab',
    'ab_test_status_draft',
    'ab_test_status_design',
    'ab_test_status_opened',
    'ab_test_status_code_offline',
    'legal',
    'legal_status',
    'legal_complete',
    'enable_sdlc',
    'sdlc_complete',
  ],
  externalHiddenControls: [
    'platform_legal_status',
    'platform_sdlc_status',
    'platform_ee_security_status',
    'online_ticket',
    'platform_libra_ab_list',
    'platform_starling_status',
    'platform_cony_mr_list',
    'platform_devops',
    'gitlab_branch',
    'repos',
    'platform_zeus_feedback_amount',
    'platform_zeus_feedback_percent',
    'platform_test_case',
    'platform_bytecycle_change_item',
    'platform_aeolus_report',
  ],
  calculationFieldHelpDoc: 'https://bytedance.feishu.cn/docs/doccnERNgCyeD0XFMTycDAEQg5g',
  showTenantIds: [],
  helpcenterUrl: 'https://project.feishu.cn/b/kahelpcenter',
}))();

export default config;
